module.exports = __webpack_public_path__ + "img/home4.b2c82fe2.png";